import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PatternRepository} from '../../../repositories/pattern.repository';
import {NavController} from '@ionic/angular';
import SewingPatternProject from '../../../models/sewing-pattern-project.model';
import {ConfiguratorService} from '../../../services/configurator/configurator.service';

@Component({
    selector: 'app-configurator-page',
    templateUrl: './configurator-page.component.html',
    styleUrls: ['./configurator-page.component.scss'],
})
export class ConfiguratorPageComponent implements OnInit, OnDestroy {

    private params$;
    public pattern;
    public project: SewingPatternProject;

    constructor(private route: ActivatedRoute, private patternRepository: PatternRepository, private configuratorService: ConfiguratorService) {
    }

    ngOnDestroy(): void {
        this.params$?.unsubscribe();
    }

    ngOnInit(): void {
        this.params$ = this.route.params.subscribe(async params => {
            if (params.projectId) {
                this.project = await this.configuratorService.getSavedSewingPatternById(params.projectId);
                return;
            }

            this.pattern = this.patternRepository.getByIdOrFirst(params.patternId);
        });
    }

    get title() {
        return this.pattern?.name ?? this.project?.name ?? '';
    }
}
